import React, {Component} from 'react'
const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'November',
  'October',
  'December'
]
class BaronSimpleDatePicker extends Component {
  constructor(props) {
    super(props)
    this.onDayChange = this.props.onDayChange || function(){
      console.log('you dont have callback');
    }
    let startingDay = new Date()
    this.state = {
      pickedDay: new Date(startingDay.setDate(startingDay.getDate() - 1))
    }
    this.allDates = []
    for (var i = 0; i < 365; i++) {
      let d = new Date(startingDay.getFullYear(), startingDay.getMonth(), startingDay.getDate() - i)
      this.allDates.push(new Date(d))
    }
  }


  updateParent = ()=>{

    this.onDayChange({month: this.state.pickedDay.getMonth() + 1, day: this.state.pickedDay.getDate()})
  }

  dateFormat = (d)=>{
    return `${MONTHS[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`
  }

  render() {
    return (
      <span className="gnm-baron-simple-date-picker">
        <select name="Historical Date"  onChange={(e)=>{
            this.setState({pickedDay: new Date(e.target.value)},this.updateParent)
          }} value={this.state.pickedDay}>
          {this.allDates.map((d,i)=>{
            return <option value={d} key={i}>{this.dateFormat(d)}</option>
          })}
        </select>
      </span>

    )
  }

}

export default BaronSimpleDatePicker



// WEBPACK FOOTER //
// ./app/components/custom/ssr/BaronSimpleDatePicker.js